const hourMinuteField = (value, required = true) => {
  if (required && (!value || value === '__:__')) {
    return 'Tijd is verplicht';
  }

  if (value === '__:__') {
    return '';
  }

  const passes = new RegExp(/^\d{2}:\d{2}$/).test(value || '');
  if (!passes) {
    return 'Tijd is onjuist';
  }

  const [hh, mm] = value?.split(':') ?? [];

  const parsedHh = parseInt(hh, 10);
  const parsedMm = parseInt(mm, 10);
  if (Number.isNaN(parsedHh) || parsedHh > 24 || Number.isNaN(parsedMm) || parsedMm > 59) {
    return 'Tijd is onjuist';
  }

  return '';
};

const timeValidators = { hourMinuteField };

export default timeValidators;
